import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import { createCookie, readCookie } from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";

const quack = () => ({
  type: Types.QUACK,
});
const loginUserAndAuthenticate = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.loginUser(data?.Username)
      .then((response) => {
        if (!!response) {
          const fullName =
            response.firstName?.trim() || response.lastName?.trim()
              ? `${response.firstName ?? ""} ${response.lastName ?? ""}`.trim()
              : (response?.userName ?? "");

          // createCookie("userguid", response?.userGuid, 1);
          // createCookie("uname", fullName, 1);
          // createCookie("accnum", response?.accountNumber, 1);

          dispatch(
            PushUserInformationToFunnelStep({
              userGUID: response?.userGuid,
              uname: fullName,
              accnum: response?.accountNumber,
              email: data.Username,
            }),
          );

          if (response?.countryCD && response?.currencyCD) {
            dispatch(
              PushUserInformationToFunnelStep({
                countryCD: response?.countryCD,
                currencyCD: response?.currencyCD,
              }),
            );
          }

          const authData = {
            Username: data.Username,
            email: data.Username,
            password: data.Password,
            userGuid: response?.userGuid,
            isSocialLogin: false,
          };
          return AssessmentServiceApi.AuthenticateExternalUser(authData).then(
            (authResponse) => {
              const { isAuth } = authResponse;
              // localStorage.setItem("jwtToken", jwtToken);
              // localStorage.setItem("refreshToken", refreshToken);
              // localStorage.setItem("expiresAt", expiresAt);
              // createCookie("jwtToken", jwtToken, 1);
              // createCookie("refreshToken", refreshToken, 1);
              // createCookie("expiresAt", expiresAt, 1);
              if (isAuth) {
                dispatch(
                  PushUserInformationToFunnelStep({
                    isAuth: isAuth,
                  }),
                );

                return response;
              } else {
                console.log("auth error");
              }
            },
          );
        } else {
          return response;
        }
      })

      .catch((error) => console.log("Error", error));
  };
};

const updateUserId = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.updateUserId(data)
      .then((response) => {
        return response;
      })
      .catch((error) => console.log("Error", error));
  };
};

const decryptURL = (token) => {
  return function () {
    return AssessmentServiceApi.decryptURL(token)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});
export { quack, loginUserAndAuthenticate, updateUserId, decryptURL };
